import { batch } from 'react-redux';
import { AppThunk } from 'store';
import { StatusLoading } from 'common/constants';
import { getResponseError, isActionItem } from 'common/utils';

import slice from '../reducer/slice';
import appSlice from '../../application/reducer/slice';
import { STATE } from '../types/state';
import { IStation, SearchStation } from 'dataSources/Typicode/stations';

type TOperation = (foundStations: { [key: string]: SearchStation }) => AppThunk;

const { setIsLoadingStations, setStations, setActionStations, setAllStations } =
  slice.actions;
const { setError } = appSlice.actions;

const operation: TOperation = (foundStations) => async (dispatch, getState) => {
  try {
    batch(() => {
      dispatch(setIsLoadingStations(StatusLoading.Load));
    });

    const state = getState();
    const {
      stations: { data: prevStations },
      allStations: { dataMap },
    } = state[STATE];
    const allStationsMap = { ...dataMap };

    let actionStations = [] as IStation[];

    let newStations = prevStations.map((station) => {
      const updatedStation = { ...station, ...foundStations[station.code] };
      allStationsMap[station.code] = updatedStation;

      if (isActionItem(station)) {
        actionStations.push(updatedStation);
      }
      return updatedStation;
    });

    batch(() => {
      dispatch(setIsLoadingStations(StatusLoading.Done));
      dispatch(setAllStations(Object.values(allStationsMap)));
      dispatch(setActionStations(actionStations));
      dispatch(setStations(newStations));
    });
  } catch (e) {
    console.info(e);
    const error = await getResponseError(e);
    dispatch(setError(error));
    dispatch(setIsLoadingStations(StatusLoading.Error));
  }
};

export default operation;
